/**
 * Проверяет, что значение является объектом-записью (не `null`, не массив).
 * Используется как type guard перед безопасным доступом к полям `unknown`.
 *
 * @param value - проверяемое значение
 * @returns `true`, если значение — объект с произвольными строковыми ключами
 */
export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);
